import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { SERVICE_LOOKUP } from 'src/environments/global.config';

export type NotificationType = 'INFO' | 'WARNING' | 'ERROR';

export interface Notification {
	noteId: string;
	noteType: NotificationType;
	title: string;
	message: string;
	requiresAction: boolean;
	tenant: string;
	adminOnly?: boolean;
	affectedResource?: string;
	createdAt?: number;
	expireAt?: number;
	identifier?: string;
	service?: string;
	status?: string;
	url?: string;
}

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	protected readonly api: string = environment.api.notification;

	constructor(protected readonly http: HttpClient) {
		const value = SERVICE_LOOKUP('notification');
		if (value != null && value.endpoint !== this.api) {
			this.api = value.endpoint;
		}
	}

	public async getNotifications(allAttributes: boolean = false): Promise<Notification[]> {
		let params;
		if (allAttributes) {
			params = new HttpParams().set('allAttributes', allAttributes);
		}
		return this.http.get<Notification[]>(`${this.api}/v1/Notifications`, { params }).toPromise();
	}

	public async describeNotification(id: string): Promise<Notification> {
		return this.http.get<Notification>(`${this.api}/v1/Notifications/${id}`).toPromise();
	}

	public async deleteNotification(id: string): Promise<any> {
		return this.http.delete<any>(`${this.api}/v1/Notifications/${id}`).toPromise();
	}
}
